import { track } from '@zillow/universal-analytics';
import { isHappyOutcome } from './calculations.js';
import { INPUTS } from './constants.js';

var VISIBLE_INPUTS = [INPUTS.annualIncome, INPUTS.monthlyDebts, INPUTS.downPayment, INPUTS.creditScore, INPUTS.cityOrZip];
var trackGAMortgageEvent = function trackGAMortgageEvent(action, label) {
  return track({
    category: 'Mortgages',
    action: action,
    label: label
  });
};

// TODO ZHLrates with the new api
var trackGACalculatorOutcome = function trackGACalculatorOutcome(data) {
  var outcomeState = isHappyOutcome(data === null || data === void 0 ? void 0 : data.outcome) ? 'happy' : 'unhappy';
  trackGAMortgageEvent('Budget Calculator: Interaction', "Calculator Outcome \"".concat(outcomeState, "\", \"ZGMIrates\""));
};
var trackGACalculatorVisible = function trackGACalculatorVisible() {
  trackGAMortgageEvent('Budget Calculator: Impression', "[".concat(VISIBLE_INPUTS.join(', '), "]"));
};
var trackGAFieldFocus = function trackGAFieldFocus(field) {
  trackGAMortgageEvent('Budget Calculator: Interaction', "Calculator Edit \"".concat(field, "\""));
};

export { trackGACalculatorOutcome, trackGACalculatorVisible, trackGAFieldFocus, trackGAMortgageEvent };
//# sourceMappingURL=analytics.js.map
